import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { AuthQuery } from '../auth';
import { User } from '../user';
import { Event } from './event.model';
import { EventParams } from './types';

export interface EventState extends EntityState<Event> {
  eventCreating: boolean;
  params: EventParams;
}

@Injectable()
@StoreConfig({ name: 'event', resettable: true })
export class EventStore extends EntityStore<EventState> {
  constructor(private authQuery: AuthQuery) {
    super({ params: new EventParams() });
    super.akitaPreAddEntity = this.akitaPreAddEntity.bind(this);
  }

  akitaPreAddEntity(event: Event): Event {
    return this.handleEvent(event, this.authQuery.getValue().user);
  }

  akitaPreUpdateEntity = (_: any, newEvent: Event) =>
    this.akitaPreAddEntity(newEvent);

  handleEvent(event: Event, user: User): Event {
    const extendedEvent: Partial<Event> = {
      extended: true,
    };

    if (user) {
      const isUserInGroup = (event.group.users || []).some((userOrId) => {
        if (!userOrId) return false;

        const id = typeof userOrId === 'string' ? userOrId : userOrId.id;
        return id === user.id;
      });

      extendedEvent.joined = isUserInGroup;
      extendedEvent.canJoin = !extendedEvent.joined && !extendedEvent.pending;
      extendedEvent.isCreator = user && user.id === event.createdBy.id;
    }

    const updatedEvent = {
      ...event,
      ...extendedEvent,
    };

    return updatedEvent;
  }
}
